<template>
  <div class="B1 sepTop" :class="bottomClass">
    <div class="bottom-content">
      <div
        class="input-container B6"
        ref="ref-input"
        @click.stop="onInputEvent"
      >
        <img src="@/static/ic_input.png" alt />
        <div class="S6 T3 tips">{{ bottomTitle }}</div>
      </div>
      <img
        v-if="id"
        class="collect"
        :src="
          require(Favored ? '@/static/ic_favored.png' : '@/static/ic_favor.png')
        "
        alt
        @click.stop="collectFun()"
      />

      <div class="text-container B1" ref="ref-text">
        <textarea
          ref="textarea"
          :placeholder="placeholder"
          class="S6 T1"
          autofocus
          rows="1"
          v-model="content"
          @focus="onFocusEvent"
          @blur="onBlurEvent"
          @change="onTextChanged"
          @keydown="onTextChanged"
          @keyup="onTextChanged"
        >
        </textarea>
        <div class="send-button" @click.stop="onCommitEvent">
          <div class="S6" :class="content.length == 0 ? 'T3' : 'C5'">发送</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '@/api/http'
import { isGuest } from '@/api/appInfo'
import util from '@/util/util'
import { isIOS } from '@/api/appInfo'

export default {
  props: {
    comment: {
      type: Object,
      default: null
    },

    commentsInfo: {
      type: Object,
      default: null
    },

    isFavored: {
      type: Boolean,
      default: false
    },
    // 控制显示收藏icon和传入收藏接口的参数
    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      focus: false,
      content: '',
      currComment: null,
      isClick: false,
      FavoredTem: false
    }
  },

  computed: {
    ...mapState('comment', ['inputType']),
    Favored() {
      if (!this.isClick) {
        return this.isFavored
      } else {
        return this.FavoredTem
      }
    },
    bottomClass() {
      return this.focus ? 'bottom-focus-container' : 'bottom-container'
    },

    // 0、可评论，1、全局禁止评论，2、该主题不允许评论，3、匿名用户不允许评论，4、该用户被禁言
    commentInputType() {
      if (this.inputType > 0) {
        return this.inputType
      }

      if (this.commentsInfo && this.commentsInfo.commentOptions > 0) {
        return this.commentsInfo.commentOptions
      }

      return 0
    },

    bottomTitle() {
      let title = '写评论'
      if (this.commentInputType == 0) {
        title = '写评论'
      } else if (this.commentInputType == 1) {
        title = '暂不能发表评论'
      } else if (this.commentInputType == 2) {
        title = '当前主题不允许评论'
      } else if (this.commentInputType == 3) {
        title = '匿名用户不允许评论'
      } else if (this.commentInputType == 4) {
        title = '您已被管理员禁言'
      }
      return title
    },

    placeholder() {
      if (this.currComment) {
        return (
          '回复 ' + (this.currComment.nickname ? this.currComment.nickname : '')
        )
      }
      return '写评论'
    }
  },

  methods: {
    async collectFun() {
      if (isGuest()) {
        util.go('ycstock://login')
        return
      }

      let { detail, result } = await http.post(
        '/Account/User/FavoriteDianJin',
        {
          tid: this.id,
          action: this.Favored ? 0 : 1
        }
      )
      if (result.code !== 0) {
        this.$toast(result.msg)
        return
      }

      if (!this.isClick) {
        if (!this.Favored && detail) {
          this.FavoredTem = true
        }
        if (this.Favored && detail) {
          this.FavoredTem = false
        }
        this.isClick = true
      } else {
        this.FavoredTem = !this.FavoredTem
      }
    },
    onInputEvent() {
      if (isGuest()) {
        util.go('ycstock://login')
        return
      }
      if (this.commentInputType !== 0) {
        return
      }

      this.startInput(this.comment)
      this.$emit('onInputEvent', this.comment)
    },

    onFocusEvent() {
      this.focus = true
      this.$emit('onFocusEvent')
      const popupDom = document.getElementsByClassName('my-popup')[0]
      if (popupDom) popupDom.style.height = '100%'
      this.$refs['textarea'].style['caret-color'] = '#262626'
    },

    onBlurEvent() {
      this.stopInput()
      this.$emit('onBlurEvent')
      const popupDom = document.getElementsByClassName('my-popup')[0]
      if (popupDom) popupDom.style.height = '120px'
    },

    onTextChanged() {
      if (this.content.length > 1000) {
        this.content = this.content.substring(0, 1000)
        this.$toast('评论内容不能超过1000字')
      }
    },

    onCommitEvent() {
      this.$emit('onCommitEvent', this.content)
      this.content = ''
      this.focus = false
      this.$refs['ref-text'].style.visibility = 'hidden'
      const popupDom = document.getElementsByClassName('my-popup')[0]
      if (popupDom) popupDom.style.height = '120px'
    },

    startInput(comment) {
      this.currComment = comment
      this.$refs['ref-text'].style.visibility = 'visible'
      this.$refs['textarea'].focus()

      this.$nextTick(() => {
        if (isIOS()) {
          document.getElementsByClassName('subcomment-list')[0].scrollTop=0
        }
      })
    },

    stopInput() {
      this.currComment = null
      if (this.content.length == 0) {
        this.focus = false
        this.$refs['ref-text'].style.visibility = 'hidden'
      }
    }
  }
}
</script>

<style scoped>
.bottom-container {
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
}

.bottom-focus-container {
  height: 200px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.bottom-content {
  width: 100%;
  height: 72px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  border-radius: 36px;
}

.text-container {
  width: 100%;
  height: 190px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  visibility: hidden;
}

.text-container textarea {
  background-color: #f3f3f3;
  border: 0;
  height: 160px;
  width: 580px;
  margin-left: 30px;
  border-radius: 10px;
  -webkit-user-select: auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  caret-color: #262626 !important;
  border: solid 0px;
  outline: none;
}

.text-container .send-button {
  width: 120px;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.input-container {
  position: absolute;
  width: 590px;
  height: 72px;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 36px;
}

.input-container img {
  width: 30px;
  height: 30px;
  margin: 0 30px;
}

.collect {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 20px;
}

.tips {
  flex: 1;
  margin-left: -10px;
}

.input-container input {
  background-color: transparent;
  border: 0;
  border-radius: 10px;
  height: 100%;
  width: 550px;
  left: 80px;
  color: #262626;
}

.input-container input:disabled {
  color: #262626;
  opacity: 1;
  -webkit-text-fill-color: #262626;
  -webkit-opacity: 1;
}
</style>
